import React from "react";
import moment from "moment";
import context from "./../../lib/context.js";

export default class TCSummary extends React.Component {
    constructor(props) {
        super(props);
        this.gotoVerifyTc = this.gotoVerifyTc.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        
    }

    gotoHome() {
        window.location = context.routeUrl("home");
    }

    gotoVerifyTc() {
        if (this.props.role === 'supervisor' )
            window.location = context.routeUrl(`${this.props.role}/tc-verify2`);
        else if(this.props.role === 'payroll-admin' )
            window.location = context.routeUrl(`${this.props.role}/tc-management2`);
    }

    render() {
        const self = this;
        const vm = this.props.vm;
        const showVerifyTcLink = (this.props.role === 'supervisor' || this.props.role === 'payroll-admin');
        let items = [];

        if (vm == null || vm.length == 0) {
           items.push(<div className="ap-fullsize ap-grid-result text-center">
                    No Timecard Found!
                </div>);
        } else {
            for (let i=0; i<vm.length; i++) {
                items.push(
                    <div className="row" style={{paddingLeft: "20px", paddingRight: "20px"}}>
                        <div className="col-sm-12 col-md-12 ap-tc-approved-list-item">
                            <div className="row">
                                <div className="col-sm-3 col-md-3 ap-label">
                                    Employee Name:</div>
                                <div className="col-sm-3 col-md-3 ap-value">
                                    {vm[i].peopleName}</div>
                                <div className="col-sm-3 col-md-3 ap-label">
                                    Total regular hours:</div>
                                <div className="col-sm-3 col-md-3 ap-value">
                                    {vm[i].regularHour} hr {vm[i].regularMin} min</div>
                            </div>
                    
                            <div className="row">
                                <div className="col-sm-3 col-md-3 ap-label">
                                    Timecard ID:</div>
                                <div className="col-sm-3 col-md-3 ap-value">
                                    {vm[i].timecardId}</div>
                                <div className="col-sm-3 col-md-3 ap-label">
                                    Total overtime hours:</div>
                                <div className="col-sm-3 col-md-3 ap-value">
                                    {vm[i].otHour} hr {vm[i].otMin} min</div>
                            </div>
                    
                            <div className="row">
                                <div className="col-sm-3 col-md-3 ap-label">
                                    Week Ending Date:</div>
                                <div className="col-sm-3 col-md-3 ap-value">
                                    {moment(vm[i].weekEnding).format("MM/DD/YYYY")}</div>
                                <div className="col-sm-3 col-md-3 ap-label">
                                    Total doubletime hours:</div>
                                <div className="col-sm-3 col-md-3 ap-value">
                                    {vm[i].dtHour} hr {vm[i].dtMin} min</div>
                            </div>
                    
                            <div className="row">
                                <div className="col-sm-6 col-md-6">
                                    </div>
                                <div className="col-sm-3 col-md-3 ap-label">
                                    Total miscellaneous hours:</div>
                                <div className="col-sm-3 col-md-3 ap-value">
                                    {vm[i].miscHour} hr {vm[i].miscMin} min</div>
                            </div>
                        </div>
                    </div>
                );
            }
        }

        return(            
            <div className="ap-form-container">                                
                <div className="container">
                    <div className="row">
                        <div className="col-sm-12 col-md-8 col-md-offset-2 ap-tc-approved">
                            The timecard(s) that you selected has been verified successfully.
                            <br />
                            You can print this confirmation page and keep it for your records.
                        </div>
                        <div className="col-sm-12 col-md-8 col-md-offset-2 ap-tc-approved-list">
                            {items}
                        </div>
                        <div className="col-sm-12 col-md-8 col-md-offset-2 ap-tc-approved" style={{borderBottom: "1px solid #CCC"}}>
                            <b>Total number of verified timecards:</b> {vm.length}
                        </div>
                        <div className={showVerifyTcLink ? "col-sm-12 col-md-4 col-md-offset-2 ap-tc-approved-link ap-text-left" : "ap-hidden"}>
                            <a href="#" onClick={this.gotoVerifyTc} className="ap-link-green">Back to Verify Timecards</a>
                        </div>
                        <div className={showVerifyTcLink ? "col-sm-12 col-md-4 ap-tc-approved-link ap-text-right" : "col-sm-12 col-md-12 ap-tc-approved-link ap-text-right"}>
                            <a href="#" onClick={this.gotoHome} className="ap-link-green">Back to Home</a>
                        </div>
                    </div>
                </div>                
            </div>);
    }
}